import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { TrainingAndPractice } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'
import { COLORS } from 'constants/layout/section-colors'

export default class TrainingAndPracticeModal extends Component {
  static propTypes = {
    colorClass: PropTypes.string,
    modalId: PropTypes.string
  }

  static defaultProps = {
    colorClass: COLORS.green.value
  }

  render() {
    const { colorClass, modalId } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        colorClass={colorClass}
        title="Preparation and Training"
        titleKey="moduleTitle.preparation_and_training"
      >
        <MaterialModal.Content>
          <TrainingAndPractice {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
